<template>
  <div id="listIPCOMTact border-radius-top-t ">
    <div class="d-flex justify-space-between align-center flex-wrap">
      <span class="text-subtitle-1 font-weight-bold my-5"
        >Etiquetas configuradas</span
      >
      <v-btn outlined class="button-gray" @click="$emit('newState', true)">
        <v-icon>mdi-plus</v-icon>
        Configuración
      </v-btn>
    </div>
    <v-data-table
      :headers="headers"
      :items="moduleList"
      :loading="loadingTable"
      item-key="id"
      disable-sort
      class="tableCustom"
    >
      <template v-slot:item.id="{ item }" class="bg-complementary">
        <div>
          {{ item.id }}
        </div>
      </template>
      <template v-slot:item.name="{ item }">
        <div>
          {{ item.name }}
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="d-flex justify-end">
          <div class="line"></div>
          <div class="contAction" @click="isActiveModule(item)">
            <v-icon v-if="item.enabled">mdi-check-circle-outline</v-icon>
            <v-icon v-else>mdi-cancel</v-icon>
          </div>
          <div @click="editModule(item)" class="contAction">
            <v-icon>mdi-pencil-outline</v-icon>
          </div>
          <div class="contAction" @click="deleteModule(item)">
            <v-icon>mdi-trash-can-outline</v-icon>
          </div>
        </div>
      </template>
    </v-data-table>
    <Delete ref="confirm"></Delete>
    <v-snackbar v-model="showError" color="red" :timeout="5000" max-width="100">
      {{ textError }}
    </v-snackbar>
  </div>
</template>
<script>
import { httpByCurrentCustomer } from "../../lib/client";
import Delete from "@/components/deleteConfirm.vue";
export default {
  components: {
    Delete,
  },
  data() {
    return {
      headers: [
        { text: "ID", value: "id" },
        { text: "Módulo", value: "name" },
        { text: "", value: "action" },
      ],
      moduleList: [],
      loadingTable: false,
      showError: false,
      textError: "",
    };
  },
  mounted() {
    this.getListIPCOMTact();
  },
  methods: {
    getListIPCOMTact() {
      this.loadingTable = true;
      httpByCurrentCustomer()
        .get("ipcomtactModules")
        .json()
        .then((res) => {
          this.moduleList = res;
          this.loadingTable = false;
        })
        .catch(() => {
          this.loadingTable = false;
          this.textError = "Ha ocurrido un error";
          this.showError = true;
        });
    },
    isActiveModule(IPComtactModule) {
      this.loadingTable = true;
      IPComtactModule.enabled = !IPComtactModule.enabled;
      const json = IPComtactModule;
      httpByCurrentCustomer()
        .put("ipcomtactModules", { json })
        .then(() => {
          this.loadingTable = false;
        })
        .catch(() => {
          this.loadingTable = false;
          this.textError =
            "Ha ocurrido un error, al activar o desactivar módulo";
          this.showError = true;
        });
    },
    async deleteModule(IPComtactModule) {
      if (
        await this.$refs.confirm.open(
          "Eliminar",
          "Esta seguro que desea elminar este módulo?",
          { color: "black" }
        )
      ) {
        this.loadingTable = true;
        const json = {
          id: IPComtactModule.id,
        };
        httpByCurrentCustomer()
          .delete("ipcomtactModules", { json })
          .then(() => {
            const idx = this.moduleList.findIndex(
              (item) => item.id == IPComtactModule.id
            );
            if (idx != -1) {
              this.moduleList.splice(idx, 1);
            }
            this.loadingTable = false;
          })
          .catch(() => {
            this.loadingTable = false;
            this.textError = "Ha ocurrido un error, al eliminar módulo";
            this.showError = true;
          });
      }
    },
    editModule(IPComtactModule) {
      const mod = Object.assign({}, IPComtactModule);
      this.$emit("editModule", mod);
    },
  },
};
</script>
<style lang="scss">
#listIPCOMTact {
  animation: fade 1s ease-in-out;
  background: white !important;
  .line {
    width: 1px;
    height: 33px;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    margin-right: 10px;
  }
  .contAction {
    width: fit-content;
    border: 1px solid #e1e8eb;
    border-radius: 4px;
    padding: 4px 9px;
    margin: 0 5px;
    cursor: pointer;
  }
}
</style>
